module.exports = __webpack_public_path__ + "img/float.e31fddee.png";